/**
 * Common types and enums for the Financial Hub.
 *
 * These mirror the DB pgEnums (see backend `tables.ts`). They are deliberately
 * **closed unions** — a new money source is a build-checked addition here, not
 * an open string registry (architecture §2 extensibility note).
 */
// ============================================
// ENUMS - Match DB enum naming
// ============================================
/**
 * The accounting kind a category belongs to. Drives report layout: Revenue −
 * Direct cost = gross margin; − Overhead = operating result; Capital and
 * Financing are kept *out* of the operating result (architecture D7).
 */
export var FinancialKind;
(function (FinancialKind) {
    FinancialKind["REVENUE"] = "REVENUE";
    FinancialKind["DIRECT_COST"] = "DIRECT_COST";
    FinancialKind["OVERHEAD"] = "OVERHEAD";
    FinancialKind["CAPITAL"] = "CAPITAL";
    FinancialKind["FINANCING"] = "FINANCING";
})(FinancialKind || (FinancialKind = {}));
/** Money flow direction of a ledger row. */
export var LedgerDirection;
(function (LedgerDirection) {
    LedgerDirection["IN"] = "IN";
    LedgerDirection["OUT"] = "OUT";
})(LedgerDirection || (LedgerDirection = {}));
/** Hub-owned review lifecycle of a ledger row. */
export var ReviewState;
(function (ReviewState) {
    ReviewState["UNREVIEWED"] = "UNREVIEWED";
    ReviewState["REVIEWED"] = "REVIEWED";
})(ReviewState || (ReviewState = {}));
/** Whether a row was projected from a source (AUTO) or hand-entered (MANUAL). */
export var EntryOrigin;
(function (EntryOrigin) {
    EntryOrigin["AUTO"] = "AUTO";
    EntryOrigin["MANUAL"] = "MANUAL";
})(EntryOrigin || (EntryOrigin = {}));
/** Posting lifecycle. Void-don't-delete: voided rows stay, excluded from totals. */
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["POSTED"] = "POSTED";
    TransactionStatus["VOID"] = "VOID";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * The operational module a money event originates from. Closed union by design
 * (architecture §2) — adding a source is a compile-checked change, not a
 * free-form string.
 */
export var SourceModule;
(function (SourceModule) {
    SourceModule["LIVESTOCK"] = "livestock";
    SourceModule["GRASS"] = "grass";
    SourceModule["EQUIPMENT"] = "equipment";
    /** Hub-originated subsystems (loans, recurring, payroll) post through the same port. */
    SourceModule["FINANCIALHUB"] = "financialhub";
})(SourceModule || (SourceModule = {}));
//# sourceMappingURL=Common.js.map